export const isSVG = (filename: string): boolean => {
  const fileEnding = filename.split('.').pop();
  return fileEnding?.toLocaleLowerCase() === 'svg';
};
